import { animate, style, transition, trigger } from '@angular/animations'

export const SlideInOut = trigger('slideInOut', [
  transition(':enter', [
    style({ height: '10px' }),
    animate('250ms ease-in', style({ height: '240px' }))
  ]),
  transition(':leave', [animate('250ms ease-in', style({ height: '0' }))])
])
